export default `
    query getNewsItems($site: [String], $section: [String], $limit: Int, $offset: Int, $id: [QueryArgument]) {
        data: entries(site: $site, section: $section, limit: $limit, offset: $offset, id: $id) {
        title
        slug
        id
        uid
            ... on news_Entry {
                postDate @formatDateTime (format: "d.m.y")
                title
                shortDescription
                url
                headerImages {
                    url @transform (width: 950, height: 480, immediately: true)
                    title
                }
            }
        }
        total: entryCount(section: $section)
    }
`;
